import { render, staticRenderFns } from "./TransProTime.vue?vue&type=template&id=4a38ab5b&scoped=true&"
import script from "./TransProTime.vue?vue&type=script&lang=js&"
export * from "./TransProTime.vue?vue&type=script&lang=js&"
import style0 from "./TransProTime.vue?vue&type=style&index=0&id=4a38ab5b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a38ab5b",
  null
  
)

export default component.exports